<template>
  <div ref="tabContent" v-if="target !== '' || isSelected || renderHidden" class="tab-content" :class="{ 'is-hidden': !isSelected || target !== '' }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  componentName: 'Tab',

  data() {
    return {
      isSelected: Boolean
    }
  },

  created() {
    this.tabs = this.$children
  },

  mounted() {
    this.isSelected = this.active
  },

  watch: {
    isSelected (value) {
      if (this.target !== '' && value) {
        const element = document.querySelector(this.target)
        element.innerHTML = this.$refs.tabContent.innerHTML
      }
    }
  },

  props: {
    name: {
      required: true
    },
    target: {
      type: String,
      default: ''
    },
    active: {
      default: false
    },
    renderHidden: {
      type: Boolean,
      default: true
    },
    uid: Number,
    activeId: String
  }
}
</script>
